/*============================================================================
  Simplified Shopify Add To Cart – Stay on Page Version
  (Cleaned and Optimized by ChatGPT, 2025)
==============================================================================*/

/*
  ✅ Features:
  - Adds products to cart using Shopify’s built-in /cart/add.js.
  - Keeps customer on the same page (no redirect).
  - Brief “Added!” feedback animation on button.
  - Automatically updates cart count (if .cart-count exists).
  - No Handlebars, no jQuery templates, no AJAX drawer logic.
  - Fully compatible with Shopify’s default checkout.
*/

if (typeof ShopifyAPI === 'undefined') { var ShopifyAPI = {}; }

/*============================================================================
  Basic Shopify API Functions (Simplified)
==============================================================================*/

ShopifyAPI.onError = function (XMLHttpRequest) {
  try {
    var data = JSON.parse(XMLHttpRequest.responseText);
    if (data && data.message) {
      alert(data.message + ' (' + data.status + '): ' + data.description);
    }
  } catch (e) {
    console.error('ShopifyAPI error', e);
  }
};

ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: { 'Accept': 'application/json' }
  })
    .then(response => {
      if (!response.ok) throw response;
      return response.json();
    })
    .then(item => {
      if (typeof callback === 'function') callback(item, form);
      else ShopifyAPI.onItemAdded(item, form);
    })
    .catch(error => {
      if (typeof errorCallback === 'function') errorCallback(error);
      else ShopifyAPI.onError(error);
    });
};

/*============================================================================
  Stay-on-Page Add To Cart Override
==============================================================================*/

document.addEventListener('DOMContentLoaded', function () {
  const addToCartForms = document.querySelectorAll('form[action^="/cart/add"]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const button = form.querySelector('[type="submit"], .add-to-cart-btn');
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(res => {
          if (!res.ok) throw res;
          return res.json();
        })
        .then(data => {
          console.log('Added to cart:', data);

          // ✅ Feedback animation
          if (button) {
            button.textContent = 'Added!';
            setTimeout(() => {
              button.disabled = false;
              button.textContent = 'Add to Cart';
            }, 1500);
          }

          // ✅ Optional: update cart count live
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              const cartCountEls = document.querySelectorAll('.cart-count');
              cartCountEls.forEach(el => el.textContent = cart.item_count);
            });

          // ✅ Optional toast notification
          const toast = document.createElement('div');
          toast.textContent = 'Product added to cart!';
          toast.className = 'cart-toast';
          document.body.appendChild(toast);
          setTimeout(() => toast.remove(), 2000);
        })
        .catch(err => {
          console.error('Add to cart failed', err);
          alert('Sorry, there was an issue adding this product. Please try again.');
          if (button) {
            button.disabled = false;
            button.textContent = 'Add to Cart';
          }
        });
    });
  });
});

/*============================================================================
  Optional Toast Styling (Add in your CSS)
==============================================================================
.cart-toast {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #333;
  color: #fff;
  padding: 12px 20px;
  border-radius: 8px;
  opacity: 0.95;
  z-index: 9999;
  font-size: 14px;
  animation: fadeInOut 2s ease;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; }
  100% { opacity: 0; transform: translateY(20px); }
}
============================================================================*/